var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NHeader',{attrs:{"theme":_vm.headerTheme}}),_c('div',{staticClass:"section"},[_c('keep-alive',{attrs:{"exclude":"newsDetail,goodsDetail"}},[_c('router-view')],1)],1),_c('NFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }